import { Injectable, Injector } from '@angular/core';
import { Observable} from 'rxjs';
import { PolicyDataService } from '@modules/policy/services/shared/policy-data.service';
import { PolicyService } from '@modules/policy/policy.service';
import { AbstractTreeService, serviceMap } from '@modules/policy/shared/components/mat-tree/serviceConfig';
import { DriverService } from './driver.service';
import { SaveService } from '@modules/policy/services/shared/save.service';
import { FormSaveHelper } from '@modules/policy/services/shared/save';

@Injectable({
  providedIn: 'root'
})
export class DriverManagerService {

  constructor(
    private policyDataService: PolicyDataService,
    private policyService: PolicyService,
    private injector: Injector,
    private saveService: SaveService,
    private SaveHelper: FormSaveHelper
  ) {}

  addDriver(SourceID: string, tabType: string): Observable<any> {
    // Get the current policy states
    const states = this.policyDataService.stateSubject.value;
    
    if (!states) {
      throw new Error('No policy states available');
    }

    // When states.driver exists, use that, otherwise fall back to client
    let DriverParentID;
    if (states.driver && states.driver.id) {
      DriverParentID = states.driver.id;
    }  else {
      throw new Error('No suitable parent node ID found in states');
    }
    const policyId = this.policyDataService.getPolicyID();
    
    // Get the driver service
    let driverService: DriverService;
    if (serviceMap["driver"]) {
      driverService = this.injector.get(serviceMap["driver"]) as DriverService;
    } else {
      throw new Error('Driver service not found');
    }

    // Call the driver service add method
    return new Observable(observer => {
      // Get the driver data first
      driverService.addAsDriver(policyId, SourceID, DriverParentID, tabType).subscribe({
        next: (res) => {
            if (res != null && res.data.parent != null) {
              //this.TreeService.setParentNodeName(res.data)
              this.policyDataService.getPolicyStates(this.policyDataService.getPolicyID()).toPromise().then((res) => {
                this.policyDataService.updateStates(res);
              });
            }
        
        },
        error: (error) => {
          console.error('DriverManagerService: Failed to add driver:', error);
        }
      });
    });
  }
}
